import { useContext } from 'react'
import { appCopyContext } from '../contexts'
import createTranslationFunc from '../utils/createTranslationFunc'

// An easy way to access the app copy context

function useAppCopy() {
  const appCopyObject = useContext(appCopyContext)
  return createTranslationFunc(appCopyObject)
}

export default useAppCopy
